export const TypeOfStudyList = ['BC', 'MG', 'NMG', 'DR'];

export const FormOfStudyList = ['PREZENCNI', 'DISTANCNI', 'KOMBINOVANE'];
